import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HtmlTemplate } from '../../dto/templates/html-template';
import { environment } from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OtherTemplatesService {
  readonly apiPathForView = environment.baseUrl + 'other-templates/';
  readonly apiPathForEdit = 'other-templates/';

  constructor(
    private http: HttpClient,
  ) { }

  getForEdit(name: string): Observable<HtmlTemplate> {
    return this.http.get(this.apiPathForEdit + name) as Observable<HtmlTemplate>;
  }

  checkExists(name: string): Observable<boolean> {

      return this.http.get(this.apiPathForView + name + '/exists', {observe: 'response', headers: {'skip-error-snack': 'true'}})
        .pipe(map(data => data.status == 200));

  }

  getForView(name: string): Observable<HtmlTemplate> {
    return this.http.get(this.apiPathForView + name) as Observable<HtmlTemplate>;
  }

  update(name: string, item: HtmlTemplate): Observable<Object> {
    return this.http.put(this.apiPathForEdit + name, item);
  }

  createTemplate(templateName: string): Observable<HtmlTemplate> {
    return this.http.post(this.apiPathForEdit, {name: templateName}) as Observable<HtmlTemplate>;
  }

  getAll() {
    return this.http.get(this.apiPathForEdit) as Observable<HtmlTemplate[]>;
  }
}
